<script setup lang="ts">
/**
 * Form PD2 (Business Address) — Practice Directive 2/2017, M32018 (Update/Add).
 * NOTIFICATION OF CHANGE IN THE BUSINESS/BRANCH ADDRESS AND/OR NATURE OF BUSINESS.
 * · Business Address 는 항상 체크(☑), Nature of Business 는 change_nature_of_business 토글.
 * · Nature of Change = "Additional Business/Branch Address" (신규/추가).
 */
import { computed, inject } from 'vue';
import { UPDATE_BUSINESS_ADDRESS_DOC_CTX } from './updateBusinessAddressContext';
import UpdateBusinessAddressDocVarField from './UpdateBusinessAddressDocVarField.vue';
import UpdateBusinessAddressSigners from './parts/UpdateBusinessAddressSigners.vue';

const ctx = inject(UPDATE_BUSINESS_ADDRESS_DOC_CTX)!;
const changeNob = computed(() => ctx.flag('change_nature_of_business'));
</script>

<template>
  <div class="uba-doc">
    <div class="doc-head">
      <div class="doc-meta">COMPANIES ACT 2016</div>
      <div class="doc-meta">Practice Directive 2/2017</div>
      <div class="doc-company notice-title">
        NOTIFICATION OF CHANGE IN THE BUSINESS/BRANCH ADDRESS AND/OR NATURE OF BUSINESS
      </div>
      <div class="doc-company" style="margin-top:8px"><UpdateBusinessAddressDocVarField field-key="company_name" /></div>
    </div>

    <p class="doc-lbl-title">Type of Change (please tick whichever applicable)</p>
    <p class="type-row">
      <span class="type-chip on">☑ Business Address / Branch Address</span>
      <span
        class="doc-toggle type-chip"
        :class="{ on: changeNob }"
        title="also changing nature of business?"
        @click="ctx.toggleFlag('change_nature_of_business')"
      >{{ changeNob ? '☑' : '☐' }} Nature of Business</span>
    </p>

    <table class="cdd-tbl">
      <tbody>
        <tr><th colspan="2">BUSINESS / BRANCH ADDRESS</th></tr>
        <tr>
          <td class="cdd-lcell">Nature of Change</td>
          <td>Additional Business/Branch Address</td>
        </tr>
        <tr>
          <td class="cdd-lcell">Effective Date of Change</td>
          <td><UpdateBusinessAddressDocVarField field-key="effective_date" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Additional Address</td>
          <td>
            <UpdateBusinessAddressDocVarField field-key="address_line_1" />,
            <UpdateBusinessAddressDocVarField field-key="address_line_2" />,
            <UpdateBusinessAddressDocVarField field-key="address_line_3" />,
            <UpdateBusinessAddressDocVarField field-key="postcode" /> <UpdateBusinessAddressDocVarField field-key="city" />,
            <UpdateBusinessAddressDocVarField field-key="state" />, <UpdateBusinessAddressDocVarField field-key="country" />
          </td>
        </tr>
      </tbody>
    </table>

    <table v-if="changeNob" class="cdd-tbl">
      <tbody>
        <tr><th colspan="2">NATURE OF BUSINESS</th></tr>
        <tr>
          <td class="cdd-lcell">Nature of Business</td>
          <td><UpdateBusinessAddressDocVarField field-key="nature_of_business" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Date of Change</td>
          <td><UpdateBusinessAddressDocVarField field-key="nature_change_date" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-lbl-title" style="margin-top:16px">Declaration:</p>
    <p class="doc-p">I confirm that the facts and information stated in this document are true and to the best of my knowledge.</p>

    <p class="doc-p"><b>Signed:</b></p>
    <UpdateBusinessAddressSigners var-key="pd2" />
    <p class="doc-p doc-sign-date"><b>Date :</b> <UpdateBusinessAddressDocVarField field-key="declaration_date" /></p>

    <div class="doc-attn">
      <b>Attention:</b>
      It is an offence under section 591 of the Companies Act 2016 to make or authorize the making of a statement
      that a person knows is false or misleading and that person may be liable, upon conviction, to imprisonment
      for a term not exceeding ten years or to a fine not exceeding RM3million or to both.
    </div>
  </div>
</template>

<style src="./updateBusinessAddressDoc.css"></style>
